import PocketBase from 'pocketbase';
import { env } from 'next-runtime-env';

const pb = (() => {
  const POCKETBASE_URL = env('NEXT_PUBLIC_POCKETBASE_URL') + '/';
  return new PocketBase(POCKETBASE_URL);
})();

export default pb;